export const CREDIT_THRESHOLDS = {
  LOW_CREDIT_WARNING: 100,
  EXPIRY_WARNING_DAYS: 4,
};

export const CREDIT_COSTS = {
  STATIC_POST: 25,
  INFOGRAPHIC: 25,
  CAROUSEL_2: 50,
  CAROUSEL_4: 100,
  CAROUSEL_6: 150,
  VIDEO_POST: 300,
  SEO_BLOG: 25,
  SEO_FAQ: 15,
  SEO_ARTICLE: 2,
  FULL_WEBSITE: 5000,
};

